import { render } from "./FilterByStatus.vue?vue&type=template&id=2b20a90c"
import script from "./FilterByStatus.vue?vue&type=script&lang=js"
export * from "./FilterByStatus.vue?vue&type=script&lang=js"

import "./FilterByStatus.vue?vue&type=style&index=0&id=2b20a90c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__